var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1129,
    height: 150,
    viewBox: "0 0 1129 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4891 73.9926L7.32664 60.8218C6.47367 59.8981 6 58.687 6 57.4297V22.3293C6 20.9082 6.60471 19.5543 7.663 18.6058L18.0647 9.28383C18.9819 8.46187 20.1701 8.00732 21.4017 8.00732H90.3066M19.4891 73.9926H66.289M19.4891 73.9926L7.07208 89.7574C6.37762 90.6391 6 91.7288 6 92.8512V126.387C6 127.674 6.49668 128.912 7.3866 129.842L18.0123 140.952C18.9555 141.939 20.2609 142.496 21.6257 142.496H90.3066",
    stroke: "#282828",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M364.745 71.9853L352.582 58.8145C351.729 57.8908 351.255 56.6796 351.255 55.4224V20.322C351.255 18.9009 351.86 17.547 352.918 16.5985L363.32 7.27651C364.237 6.45455 365.426 6 366.657 6H435.562M364.745 71.9853H411.544M364.745 71.9853L352.328 87.7501C351.633 88.6318 351.255 89.7215 351.255 90.8439V124.379C351.255 125.667 351.752 126.905 352.642 127.835L363.268 138.945C364.211 139.931 365.516 140.489 366.881 140.489H435.562",
    stroke: "#282828",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1051.24 71.9853L1039.08 58.8145C1038.23 57.8908 1037.75 56.6796 1037.75 55.4224V20.322C1037.75 18.9009 1038.36 17.547 1039.41 16.5985L1049.82 7.27651C1050.73 6.45455 1051.92 6 1053.15 6H1122.06M1051.24 71.9853H1098.04M1051.24 71.9853L1038.82 87.7501C1038.13 88.6318 1037.75 89.7215 1037.75 90.8438V124.379C1037.75 125.667 1038.25 126.905 1039.14 127.835L1049.76 138.945C1050.71 139.931 1052.01 140.489 1053.38 140.489H1122.06",
    stroke: "#282828",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.427 8.00732L201.712 142.496",
    stroke: "#282828",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M207.734 8.00732L123.427 142.496",
    stroke: "#282828",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M322.15 10.0146H258.92L237.843 29.084V121.42L258.92 140.489H322.15",
    stroke: "#282828",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M464.668 6V141.493H546.967",
    stroke: "#282828",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M620.234 8.00732V140.489",
    stroke: "#282828",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M963.482 10.0146V142.496",
    stroke: "#282828",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M578.08 140.489H662.387M578.08 8.00732H662.387",
    stroke: "#282828",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M921.328 10.0146H1005.64",
    stroke: "#282828",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M694.504 141.493V76.2554M694.504 76.2554V11.0182H755.726L773.792 27.0766V61.2007L755.726 75.2518L694.504 76.2554ZM694.504 76.2554L773.792 141.493",
    stroke: "#282828",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M806.912 143.5V77.2592L849.066 8.00732L890.215 77.2592V143.5",
    stroke: "#282828",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M806.912 80.27H890.215",
    stroke: "#282828",
    strokeWidth: 12
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainText);
export default __webpack_public_path__ + "static/media/main-text.90620fccd91ec2ce033685248ddc9418.svg";
export { ForwardRef as ReactComponent };